import VueApexCharts from "vue-apexcharts";
import {
    getSumavg,
    getLibCourse,
    getViewCourse,
    getTicketExam,
    getViewLive,
    getStudentRegister,
    getStudentOnline,
    getExcel,
} from "@/service/dashboard/dashboard";
import datePicker from "@/views/dashboard/daily/dialog/datepicker.vue";
import downloadexcel from "vue-json-excel";
export default {
    props: {
        sendReportDaily: {
            type: Object,
        },
        dataGroupSelect: {
            type: Array,
        },
        dataIsGroupNull: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        datePicker,
        downloadexcel,
        apexchart: VueApexCharts,
    },

    data() {
        return {
            loaddata: false,
            dataParams: [],
            datepicker: false,
            startTime: "",
            endTime: "",
            countDay: 0,
            tab: "tab1Modal",
            fileExcelName: "reportDaily.xls",
            json_fields: {
                วันที่: "startDay",
                การซื้อคอร์ส: "countLibCourse",
                การดูคลิป: "countViewVideo",
                การทำข้อสอบ: "countTicketExam",
                การดูไลฟ์สด: "countViewLive",
                สมาชิกใหม่: "countStudentRegister",
                คนออนไลน์: "countStudentOnline",

            },
            chartOptions: {
                chart: {
                    // toolbar: {
                    //     show: false,
                    // },
                    type: "area",
                    stacked: true,
                },

                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth',
                },
                xaxis: {
                    type: 'category'
                },
                yaxis: {
                    title: {
                        text: 'คน'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " คน"
                        }
                    }
                }
            },
            series: [{
                name: "graph",
                data: []
            }],
            statusTab: 1,
            buyCourseSeries: [],
            viewCourseSeries: [],
            ticketExamSeries: [],
            viewLiveSeries: [],
            onlineUserSeries: [],
            registerSeries: [],
            sumLibCourse: 0,
            sumStudentOnline: 0,
            sumStudentRegister: 0,
            sumTicketExam: 0,
            sumViewLive: 0,
            sumViewVideo: 0,
            dataGroup: [],
        }
    },
    mounted() {
        this.initialize()
    },
    watch: {
        sendReportDaily(value) {
            this.sendReportDaily = value
            this.initialize()
        },
        dataGroupSelect(value) {
            this.dataGroup = value
            console.log("daily", this.dataGroup)
            this.setTimeDashboardDaily(this.dataParams.starttime, this.dataParams.endtime)
        },
    },
    methods: {
        formatDate(datatime) {

            let date = new Date((datatime))
            let monthNamesThai = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.",
                "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."]
            var Str =
                date.getDate()
                + " " + monthNamesThai[(date.getMonth())]
                + " " + (date.getFullYear() + 543)
            return Str
        },
        async exportReport() {
            this.loaddata = true
            let dataParams = {
                starttime: this.dataParams.starttime,
                endtime: this.dataParams.endtime,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            }
            let dataExal = await getExcel(dataParams);
            this.loaddata = dataExal ? false : true
            return dataExal ? dataExal.arrayResult : []
        },
        async initialize() {
            this.loaddata = true
            let dataParams = this.sendReportDaily.dataParams
            this.dataParams = {
                starttime: dataParams ? (new Date(dataParams.starttime)).getTime() : 0,
                endtime: dataParams ? (new Date(dataParams.endtime)).getTime() : 0,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            };
            console.log("dataParams", this.dataParams)
            this.dataParams = dataParams
            this.startTime = dataParams ? await this.formatDate(dataParams.starttime) : ""
            this.endTime = dataParams ? await this.formatDate(dataParams.endtime) : ""
            this.countDay = dataParams ? ((dataParams.endtime - dataParams.starttime) / (24 * 60 * 60 * 1000)) + 1 : 0


            let resultSumAvg = this.sendReportDaily.getSumavg;
            let result = this.sendReportDaily.getLibCourse
            let arrayBuyCourse = []
            if (result) {
                await result.arrayResult.forEach((Item, index) => {
                    arrayBuyCourse.push({ y: Item.countLibCourse, x: Item.startDay })
                })
            }

            let dataChart = {
                arrayBuyCourse: arrayBuyCourse,
            }
            this.loaddata = arrayBuyCourse.length ? false : true
            this.buyCourseSeries = [{
                name: 'จำนวนคน',
                data: dataChart.arrayBuyCourse
            }]
            if (resultSumAvg) {
                this.sumLibCourse = resultSumAvg.sumLibCourse
                this.sumStudentOnline = resultSumAvg.sumStudentOnline
                this.sumStudentRegister = resultSumAvg.sumStudentRegister
                this.sumTicketExam = resultSumAvg.sumTicketExam
                this.sumViewLive = resultSumAvg.sumViewLive
                this.sumViewVideo = resultSumAvg.sumViewVideo
            }


            this.statusTab = 1
            this.series = this.buyCourseSeries
        },
        async buyCourseSeriesFn() {
            this.statusTab = 1
            this.loaddata = true
            let dataParams = {
                starttime: this.dataParams.starttime,
                endtime: this.dataParams.endtime,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            }
            let result = await getLibCourse(dataParams)
            let arrayGraph = []
            if (result) {
                await result.arrayResult.forEach((Item, index) => {
                    arrayGraph.push({ y: Item.countLibCourse, x: Item.startDay })
                })
            }

            this.series = [{
                name: 'จำนวนคน',
                data: arrayGraph
            }]
            this.loaddata = arrayGraph.length ? false : true

        },
        async viewCourseSeriesFn() {
            this.statusTab = 2
            this.loaddata = true
            let dataParams = {
                starttime: this.dataParams.starttime,
                endtime: this.dataParams.endtime,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            }
            let result = await getViewCourse(dataParams)
            let arrayGraph = []
            if (result) {
                await result.arrayResult.forEach((Item, index) => {
                    arrayGraph.push({ y: Item.countViewVideo, x: Item.startDay })
                })
            }
            this.series = [{
                name: 'จำนวนคน',
                data: arrayGraph
            }]
            this.loaddata = arrayGraph.length ? false : true

        },
        async onlineUserSeriesFn() {
            this.statusTab = 3
            this.loaddata = true
            let dataParams = {
                starttime: this.dataParams.starttime,
                endtime: this.dataParams.endtime,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            }
            let result = await getStudentOnline(dataParams)
            let arrayGraph = []
            if (result) {
                await result.arrayResult.forEach((Item, index) => {
                    arrayGraph.push({ y: Item.countStudentOnline, x: Item.startDay })
                })
            }
            this.series = [{
                name: 'จำนวนคน',
                data: arrayGraph
            }]
            this.loaddata = arrayGraph.length ? false : true
        },
        async ticketExamSeriesFn() {
            this.statusTab = 4
            this.loaddata = true
            let dataParams = {
                starttime: this.dataParams.starttime,
                endtime: this.dataParams.endtime,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            }
            let result = await getTicketExam(dataParams)
            let arrayGraph = []
            if (result) {
                await result.arrayResult.forEach((Item, index) => {
                    arrayGraph.push({ y: Item.countTicketExam, x: Item.startDay })
                })
            }
            this.series = [{
                name: 'จำนวนคน',
                data: arrayGraph
            }]
            this.loaddata = arrayGraph.length ? false : true
        },
        async viewLiveSeriesFn() {
            this.statusTab = 5
            this.loaddata = true
            let dataParams = {
                starttime: this.dataParams.starttime,
                endtime: this.dataParams.endtime,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            }
            let result = await getViewLive(dataParams)
            let arrayGraph = []
            if (result) {
                await result.arrayResult.forEach((Item, index) => {
                    arrayGraph.push({ y: Item.countViewLive, x: Item.startDay })
                })
            }
            this.series = [{
                name: 'จำนวนคน',
                data: arrayGraph
            }]
            this.loaddata = arrayGraph.length ? false : true
        },
        async registerSeriesFn() {
            this.statusTab = 6
            this.loaddata = true
            let dataParams = {
                starttime: this.dataParams.starttime,
                endtime: this.dataParams.endtime,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            }
            let result = await getStudentRegister(dataParams)
            let arrayGraph = []
            if (result) {
                await result.arrayResult.forEach((Item, index) => {
                    arrayGraph.push({ y: Item.countStudentRegister, x: Item.startDay })
                })
            }
            this.series = [{
                name: 'จำนวนคน',
                data: arrayGraph
            }]
            this.loaddata = arrayGraph.length ? false : true
        },
        async setTimeDashboardDaily(start, end) {

            let dataParams = {
                starttime: start,
                endtime: end,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            }
            console.log("setTimeDashboardDaily", dataParams)
            this.loaddata = true
            this.startTime = dataParams.starttime ? await this.formatDate(dataParams.starttime) : ""
            this.endTime = dataParams.endtime ? await this.formatDate(dataParams.endtime) : ""
            this.countDay = dataParams.endtime ? ((dataParams.endtime - dataParams.starttime) / (24 * 60 * 60 * 1000)) + 1 : 0
            let result = await getSumavg(dataParams);
            if (result) {
                this.sumLibCourse = result.sumLibCourse
                this.sumStudentOnline = result.sumStudentOnline
                this.sumStudentRegister = result.sumStudentRegister
                this.sumTicketExam = result.sumTicketExam
                this.sumViewLive = result.sumViewLive
                this.sumViewVideo = result.sumViewVideo
                this.loaddata = result ? false : true
            }

            switch (this.statusTab) {
                case 1:
                    await this.buyCourseSeriesFn()
                    break;
                case 2:
                    await this.viewCourseSeriesFn()
                    break;
                case 3:
                    await this.onlineUserSeriesFn()
                    break;
                case 4:
                    await this.ticketExamSeriesFn()
                    break;
                case 5:
                    await this.viewLiveSeriesFn()
                    break;
                case 6:
                    await this.registerSeriesFn()
                    break;
                default:
                    await this.buyCourseSeriesFn()
                    break;
            }
        },
        sendStartTime(val) {
            this.dataParams = {
                starttime: (new Date(val.startTime)).getTime(),
                endtime: (new Date(val.endTime)).getTime(),
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            };
            console.log(this.dataParams)
        },
        openDialogdatepicker() {
            this.datepicker = true
        },
        closeDialogdatepicker() {
            this.datepicker = false
        },
        async okDialogdatepicker() {
            this.buyCourseSeries = []
            this.viewCourseSeries = []
            this.ticketExamSeries = []
            this.viewLiveSeries = []
            this.onlineUserSeries = []
            this.registerSeries = []
            this.datepicker = false

            await this.setTimeDashboardDaily(this.dataParams.starttime, this.dataParams.endtime)

        },
        async changeDialogdatepickerLeft() {
            this.buyCourseSeries = []
            this.viewCourseSeries = []
            this.ticketExamSeries = []
            this.viewLiveSeries = []
            this.onlineUserSeries = []
            this.registerSeries = []
            let newStartTime = this.dataParams.starttime - ((this.countDay - 1) * (24 * 60 * 60 * 1000))
            let newEndTime = this.dataParams.starttime
            this.dataParams = {
                starttime: newStartTime,
                endtime: newEndTime,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            };
            console.log(this.dataParams)
            await this.setTimeDashboardDaily(newStartTime, newEndTime)
        },
        async changeDialogdatepickerRight() {
            this.buyCourseSeries = []
            this.viewCourseSeries = []
            this.ticketExamSeries = []
            this.viewLiveSeries = []
            this.onlineUserSeries = []
            this.registerSeries = []
            let newStartTime = this.dataParams.endtime
            let newEndTime = this.dataParams.endtime + ((this.countDay - 1) * (24 * 60 * 60 * 1000))
            this.dataParams = {
                starttime: newStartTime,
                endtime: newEndTime,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            };
            console.log(this.dataParams)
            await this.setTimeDashboardDaily(newStartTime, newEndTime)
        }
    }
}